/* eslint semi:0 */
import BaseVm from './BaseVm'
import { m } from '../../utils/mithril'
import { CLASS_NAMES as INPUT_CLASS_NAMES } from '../views/InputView'

class SignupModalVm extends BaseVm {
  constructor(options = {}) {
    super(options)
    this.merge({
      formData: {},
      isLoading: m.prop(false),
      isFormValid: m.prop(false),
      serverValidationErrors: m.prop({}),
      selectedLeague: m.prop(this.localeLeague),
    })
  }

  get isFacebookDataLoaded() {
    return this.store.isFacebookDataLoaded
  }

  get languages() {
    return this.store.languages || []
  }

  get leagues() {
    return this.store.leagues || []
  }

  get localeLeague() {
    return this.store.localeLeague
  }

  get localeLeagueName() {
    return this.store.localeLeagueName
  }

  get teams() {
    return this.store.teams || []
  }

  get termsUrl() {
    return this.store.termsUrl
  }

  get authId() {
    return this.store.authId
  }

  get randomInt() {
    return parseInt(Math.random() * 10000, 10)
  }

  onFieldChange(event) {
    // console.info('onFormChange', event, this.formData, this)
    let { target } = event
    target.classList.add(INPUT_CLASS_NAMES.VISITED)
    let { name, value } = target
    if (name) {
      this.formData[name] = value
    }
    this.isFormValid(this.formValidityGetter())
  }

  submit(event) {
    event.preventDefault()
    let data = new FormData(event.currentTarget)
    data.append('ieCompatible', 'true') // This line is needed for FormData to work in ie
    this.store.submit(data)
  }
}

export default SignupModalVm



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/SignupModalVm.js